/**
 * Константы скролла ПК. Менять скорость — только LERP.
 */

export const MAX_PROGRESS = 5;
export const DESKTOP_MQ = "(min-width: 1101px)";
export const REDUCE_MQ = "(prefers-reduced-motion: reduce)";
export const LERP = 0.18;
export const SETTLE = 0.0005;

export function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

// hooks/pcScroll/pcScrollConstants.js
